export default "__VITE_ASSET__C_FHZsN___"